import React, {FunctionComponent, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {ValidatorForm} from "react-material-ui-form-validator";
import {Step} from "../../../WizardMap";
import WizardStep from "../../WizardStep";
import statusContact from "../../../../images/Progress/kontakt_icn.svg";
import {makeStyles} from "@material-ui/core";
import {longInputWith} from "./StepContactData";
import {RootState} from "../../../../redux/rootReducer";
import CommonTextInput from "../../../../commonComponents/ValidateTextInput";
import {
    setBirthday,
    setEmail,
    setPhone
} from "../../../state/contactSlice";
import NotificationSettings from "./NotificationSettings";
import moment, {Moment} from "moment";
import DatePicker from "../../../../commonComponents/DatePicker";
import {NavigationProps} from "../../../slideRouter/navigationHook";
// @ts-ignore
import MuiPhoneNumber from "material-ui-phone-number";

const useStyles = makeStyles(() => ({
    formContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    longTextInput: {
        width: longInputWith,
        marginBottom: 20
    },
    longWithContainer: {
        width: longInputWith,
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 20
    },
    notificationContainer: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        width: longInputWith,
        marginTop: 50
    },
    phoneInput: {
        width: longInputWith,
        display: "flex",
        justifyContent: "space-between",
        padding: 0,
        margin: 0
    },
    inputLabel: {
        color: "#999"
    },
    phoneDropDown: {
        padding: 0,
        margin: 0,
        borderRadius: 5,
        color: "#000"
    }
}));

const StepContactDataMobile2: FunctionComponent<NavigationProps> = ({gotoPrevSlide, gotoNextSlide}) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const formRef = useRef<ValidatorForm | null>(null);
    const {birthday, email, phone, notificationType} = useSelector((state: RootState) => state.contact);

    const [isUnder18, setIsUnder18] = useState<boolean>(false);
    const [phoneError, setPhoneError] = useState<boolean>(false);

    const handleFormSubmit = (): void => {
        if (formRef.current) {
            formRef.current.isFormValid(false).then(isValid => {
                if (!birthday) {
                    setIsUnder18(true);
                }
                phone.length > 3 ? setPhoneError(false) : setPhoneError(true);
                birthday && !isUnder18 && phone.length > 3 && isValid && gotoNextSlide(Step.SHIPPING_TYPE);
            });
        }
    };

    const onChangeBirthday = (birthday: Moment) => {
        if (moment().diff(birthday, "years", true) < 18) {
            setIsUnder18(true);
        } else {
            setIsUnder18(false);
        }
        dispatch(setBirthday(birthday ? birthday.toObject() : undefined));
    };

    const handleBackClicked = (): void => {
        gotoPrevSlide();
    };

    return (
        <WizardStep
            title={"Bitte geben Sie Ihre Kontaktdaten an"}
            icon={statusContact}
            backButton
            onBackClick={handleBackClicked}
            nextButton
            onNextClick={handleFormSubmit}
        >
            <ValidatorForm
                ref={formRef}
                onSubmit={() => {
                }}
                className={classes.formContainer}
                instantValidate={false}
            >
                <DatePicker
                    label={"Geburtstag"}
                    value={birthday ? moment(birthday) : null}
                    onSelectDate={(date: Moment | null) => onChangeBirthday(date as Moment)}
                    error={isUnder18}
                    errorText={isUnder18 ? "Nicht 18" : ""}
                    inputStyle={{width: longInputWith, marginBottom: 20}}
                    openTo={"year"}
                    views={["year", "month", "date"]}
                    autoOk
                />
                <CommonTextInput
                    name="email"
                    label="E-Mail"
                    validators={["required", "isEmail"]}
                    errorMessages={["erforderlich", "invalid email"]}
                    value={email}
                    onChangeText={(text: string) => dispatch(setEmail(text))}
                    className={classes.longTextInput}
                />
                <MuiPhoneNumber
                    label={"Telefon"}
                    value={phone}
                    InputLabelProps={{className: classes.inputLabel}}
                    InputProps={{style: {color: "#000"}}}
                    inputClass={classes.phoneInput}
                    dropdownClass={classes.phoneDropDown}
                    defaultCountry={"de"}
                    error={phoneError}
                    helperText={phoneError ? "erforderlich" : undefined}
                    // onlyCountries={["de", "ch", "at"]}
                    regions={["european-union"]}
                    localization={{"Germany": "Deutschland", "Austria": "Österreich", "Switzerland": "Schweiz"}}
                    countryCodeEditable={false}
                    onChange={(val: string) => dispatch(setPhone(val))}
                />
            </ValidatorForm>
            <NotificationSettings notificationType={notificationType} className={classes.notificationContainer}/>
        </WizardStep>
    );
};

export default StepContactDataMobile2;
